module.exports = __webpack_public_path__ + "img/a2ac58bbd79d3cf5e7dd94ab7085955a.png";